<template>
  <div class="d-flex flex-column i-gap-4">
    <i-text-input
      :value="notesText"
      label="Notes"
      :mode="iTextInputModes.TEXTAREA"
      :placeholder="placeholder"
      @input="notesText = $event"
    ></i-text-input>
    <i-button
      text="Save"
      v-read-only-check
      type="secondary"
      subtype="strong"
      size="xs"
      @button-click="() => saveNote()"
    ></i-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
  iButton,
  iTextInput,
  iTextInputModes,
  showToast,
} from '@inscribe/signal';

export default {
  components: { iButton, iTextInput },
  data() {
    return {
      notesText: '',
      placeholder: 'Write a note about this customer...',
      keepInBounds: true,
      iTextInputModes,
    };
  },
  computed: {
    ...mapState({
      selectedCustomer: (state) => state.customers.selectedCustomer,
    }),
  },
  mounted() {
    this.notesText = this.selectedCustomer.notes;
  },
  methods: {
    ...mapMutations(['updateSelectedCustomer']),
    saveNote() {
      this.$store
        .dispatch('updateCustomer', {
          ...this.$store.state.customers.selectedCustomer,
          notes: this.notesText,
        })
        .then(
          (response) => {
            this.updateSelectedCustomer({
              notes: this.notesText,
            });
            showToast({
              text: 'Customer notes saved.',
            });
          },
          (errorResponse) => {
            if (
              errorResponse.response !== undefined &&
              errorResponse.response.status === 403
            ) {
              showToast({
                title: 'Permission denied',
                text: 'You do not have permission to change this customers notes. Please contact your admin if you require this permission.',
                isError: true,
              });
            }
          },
        );
    },
  },
};
</script>
